var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centent"},[_c('div',{staticClass:"titlefont",class:{ sSixKeys: _vm.sSixKeys }},[_vm._m(0)]),_c('div',{staticClass:"cont"},[_c('div',[_c('ul',{staticClass:"sixItems",class:{ sSixKeys: _vm.sSixKeys }},_vm._l((_vm.sixthScreen),function(item,index){return _c('li',{key:index,staticClass:"item",class:{
            itemA: index == 0,
            itemB: index == 1,
            itemC: index == 2,
            itemD: index == 3,
          }},[_c('p',{staticClass:"tit"},[_c('img',{attrs:{"src":item.url}})]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(item.title))])])}),0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleAnimation"},[_c('div',{staticClass:"title"},[_vm._v("针对四类人群 研发专属项目")]),_c('div',{staticClass:"desc"},[_vm._v("来，一起做朝阳行业的“弄潮儿”")])])
}]

export { render, staticRenderFns }